import SalesSuppliersMSTImportPage from './SalesSuppliersMSTImportPage';

export default SalesSuppliersMSTImportPage;
